import invoiceApi from "../../../api/account/invoice";

const state = {
  due: {},
  dueLst: [],
  pass: {},
  passLst: [],
  pdf: {},
  pdfLst: []
};

const getters = {};

const mutations = {
  // 存个列表
  setDueLst(state, { data, type }) {
    if (type && type == 1) {
      state.dueLst = [];
    }
    state.due = data;
    state.dueLst = state.dueLst.concat(data.list);
  },
  // 存个列表
  setPassLst(state, { data, type }) {
    if (type && type == 1) {
      state.passLst = [];
    }
    state.pass = data;
    state.passLst = state.passLst.concat(data.list);
    console.log(state.pass);
    console.log(state.passLst);
  },
  setPdfLst(state, { data, type }) {
    if (type && type == 1) {
      state.pdfLst = [];
    }
    state.pdf = data;
    state.pdfLst = state.pdfLst.concat(data.list);
  },
  // 更新标记状态
  updateMark(state, { id, type }) {
    if (type == "due") {
      state.dueLst.find((v, i) => {
        if (v.id == id) {
          state.dueLst.splice(i, 1);
          state.due.totalRecord = state.due.totalRecord - 1;
          return;
        }
        return;
      });
    } else {
      state.passLst.find((v, i) => {
        if (v.id == id) {
          state.passLst.splice(i, 1);
          state.pass.totalRecord = state.pass.totalRecord - 1;
          return;
        }
        return;
      });
    }
  }
};

const actions = {
  // 获取列表
  getDueLst({ state }, { params, callback }) {
    state.due = {};
    invoiceApi.getDueLstApi({ params, callback }, res => {
      callback(res);
    });
  },
  // 获取列表
  getPassLst({ state }, { params, callback }) {
    state.pass = {};
    invoiceApi.getPassLstApi({ params, callback }, res => {
      callback(res);
    });
  },
  // 获取列表
  getPdfLst({ state }, { params, callback }) {
    state.pass = {};
    invoiceApi.getPdfLstApi({ params, callback }, res => {
      callback(res);
    });
  },
  // 标记
  markPut({ state }, { params, callback }) {
    console.log(state);
    invoiceApi.markApi({ params, callback }, res => {
      callback(res);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/account/invoice.js